export default "__VITE_ASSET__d76b7fb0__"